import React from 'react'
import MaterialSymbol from '../material-symbol'

const KeyboardArrowDown = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="keyboard_arrow_down" {...props} />
))

KeyboardArrowDown.displayName = 'KeyboardArrowDown'

export default KeyboardArrowDown
